import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import SmartStaysLogo from '../components/SmartStaysLogo';
import API_URL from '../config';
import { validateRequiredFields, clearFieldInvalid } from '../utils/formValidation';
import './Activate.css';
import '../publicTheme.css';

// Publieke pagina voor een uitgelogde gebruiker die zijn wachtwoord vergeten
// is. Vraagt enkel het e-mailadres op en stuurt dat door naar het publieke
// backend-endpoint POST /api/forgot-password. Dat endpoint antwoordt altijd
// met dezelfde generieke melding (ongeacht of het adres echt bestaat), dus
// hier is bewust geen foutmelding zoals "dit e-mailadres bestaat niet" - dat
// zou toelaten om te achterhalen welke e-mailadressen een account hebben.
// Het eigenlijke nieuwe-wachtwoord-invullen (2x, ter controle) gebeurt op de
// al bestaande /reset-password/:token pagina, via de link in de mail.
function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  useEffect(() => {
    document.title = 'SmartStays - Wachtwoord vergeten';
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateRequiredFields(e.target)) {
      setMessage(t('forgotPassword.fillAll'));
      setMessageType('error');
      return;
    }

    setLoading(true);
    try {
      const response = await axios.post(`${API_URL}/api/forgot-password`, { email });
      setMessage(response.data.message);
      setMessageType('success');
      setDone(true);
    } catch (err) {
      setMessage(err.response?.data?.error || t('forgotPassword.failed'));
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="activate-container">
      <div className="activate-card">
        <div className="activate-header">
          <h1><SmartStaysLogo /></h1>
          <p>{t('forgotPassword.subtitle')}</p>
        </div>

        {!done && (
          <form onSubmit={handleSubmit} noValidate onInput={clearFieldInvalid}>
            <div className="form-group">
              <label>{t('forgotPassword.email')}</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            {message && (
              <div className={`message ${messageType}`}>
                {message}
              </div>
            )}

            <button type="submit" disabled={loading}>
              {loading ? t('forgotPassword.loading') : t('forgotPassword.submit')}
            </button>
          </form>
        )}

        {done && message && (
          <div className={`message ${messageType}`}>
            {message}
          </div>
        )}

        <p className="reset-back-link">
          <Link to="/login">{t('forgotPassword.backToLogin')}</Link>
        </p>
      </div>
    </div>
  );
}

export default ForgotPassword;
